// extracted by mini-css-extract-plugin
export default {"wrapper":"TextBlock_wrapper__HcQfD","text":"TextBlock_text__6DZYt","list":"TextBlock_list__zez-f","listItem":"TextBlock_listItem__Yy6LA"};